import { styles } from './styles';

export const SortByNameDesc = (): JSX.Element => (
  <svg
    width="69"
    height="32"
    viewBox="0 0 69 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 3C1 1.89543 1.89543 1 3 1H66C67.1046 1 68 1.89543 68 3V29C68 30.1046 67.1046 31 66 31H3C1.89543 31 1 30.1046 1 29V3Z"
      fill={styles.background}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 0H66C67.6569 0 69 1.34315 69 3V29C69 30.6569 67.6569 32 66 32H3C1.34314 32 0 30.6569 0 29V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V29C1 30.1046 1.89543 31 3 31H66C67.1046 31 68 30.1046 68 29V3C68 1.89543 67.1046 1 66 1H3Z"
      fill={styles.border}
    />
    <path
      d="M4 5C4 3.89543 4.89543 3 6 3H63C64.1046 3 65 3.89543 65 5V6.77778C65 7.88235 64.1046 8.77778 63 8.77778H6C4.89543 8.77778 4 7.88235 4 6.77778V5Z"
      fill={styles.element}
    />
    <path
      d="M14.5172 5.78191C14.5172 5.04325 15.116 4.44446 15.8547 4.44446H61.5591C62.2978 4.44446 62.8966 5.04325 62.8966 5.78191C62.8966 6.52056 62.2978 7.11935 61.5591 7.11935H15.8547C15.116 7.11935 14.5172 6.52056 14.5172 5.78191Z"
      fill={styles.background}
    />
    <path
      d="M4 11.7407C4 10.6362 4.89543 9.74072 6 9.74072H63C64.1046 9.74072 65 10.6362 65 11.7407V13.5185C65 14.6231 64.1046 15.5185 63 15.5185H6C4.89543 15.5185 4 14.6231 4 13.5185V11.7407Z"
      fill={styles.element}
    />
    <path
      d="M14.5172 12.5226C14.5172 11.784 15.116 11.1852 15.8547 11.1852H61.5591C62.2978 11.1852 62.8966 11.784 62.8966 12.5226C62.8966 13.2613 62.2978 13.8601 61.5591 13.8601H15.8547C15.116 13.8601 14.5172 13.2613 14.5172 12.5226Z"
      fill={styles.background}
    />
    <path
      d="M4 18.4814C4 17.3769 4.89543 16.4814 6 16.4814H63C64.1046 16.4814 65 17.3769 65 18.4814V20.2592C65 21.3638 64.1046 22.2592 63 22.2592H6C4.89543 22.2592 4 21.3638 4 20.2592V18.4814Z"
      fill={styles.element}
    />
    <path
      d="M14.5172 19.2634C14.5172 18.5247 15.116 17.9259 15.8547 17.9259H61.5591C62.2978 17.9259 62.8966 18.5247 62.8966 19.2634C62.8966 20.002 62.2978 20.6008 61.5591 20.6008H15.8547C15.116 20.6008 14.5172 20.002 14.5172 19.2634Z"
      fill={styles.background}
    />
    <path
      d="M4 25.2222C4 24.1176 4.89543 23.2222 6 23.2222H63C64.1046 23.2222 65 24.1176 65 25.2222V26.9999C65 28.1045 64.1046 28.9999 63 28.9999H6C4.89543 28.9999 4 28.1045 4 26.9999V25.2222Z"
      fill={styles.element}
    />
    <path
      d="M14.5172 26.0041C14.5172 25.2654 15.116 24.6666 15.8547 24.6666H61.5591C62.2978 24.6666 62.8966 25.2654 62.8966 26.0041C62.8966 26.7427 62.2978 27.3415 61.5591 27.3415H15.8547C15.116 27.3415 14.5172 26.7427 14.5172 26.0041Z"
      fill={styles.background}
    />
    <path
      d="M10.8562 7.56934H8.2V7.07861L9.91142 4.625H8.24638V4H10.8099V4.48828L9.10088 6.94434H10.8562V7.56934Z"
      fill={styles.highlight}
    />
    <path
      d="M9.56006 12.4697L10.3047 11H11.1201L9.93604 13.1802V14.5693H9.18408V13.2046L8 11H8.82031L9.56006 12.4697Z"
      fill={styles.highlight}
    />
    <path
      d="M11.335 21.0693H10.4707L9.64062 19.7192L8.81055 21.0693H8L9.18408 19.2285L8.07568 17.5H8.91064L9.67969 18.7842L10.4341 17.5H11.2495L10.1289 19.27L11.335 21.0693Z"
      fill={styles.highlight}
    />
    <path
      d="M11.8 24.5L10.9921 27.725H10.2255L9.79551 26.0309C9.78682 25.9985 9.77524 25.9493 9.76076 25.8831C9.74628 25.8169 9.73108 25.7449 9.71515 25.6669C9.69923 25.5875 9.68475 25.5132 9.67172 25.4441C9.66013 25.3735 9.65217 25.3176 9.64783 25.2765C9.64349 25.3176 9.6348 25.3728 9.62177 25.4419C9.61019 25.511 9.59643 25.5846 9.58051 25.6625C9.56603 25.7404 9.55155 25.8132 9.53707 25.8809C9.52259 25.9485 9.51101 26 9.50232 26.0353L9.0745 27.725H8.31005L7.5 24.5H8.16237L8.56848 26.2603C8.58007 26.3132 8.5931 26.3765 8.60758 26.45C8.6235 26.5235 8.6387 26.6007 8.65318 26.6816C8.66911 26.761 8.68286 26.8382 8.69444 26.9132C8.70747 26.9868 8.71689 27.0507 8.72268 27.1051C8.72992 27.0493 8.73933 26.9846 8.75091 26.911C8.76249 26.836 8.7748 26.7603 8.78783 26.6838C8.80231 26.6059 8.81678 26.5338 8.83126 26.4676C8.84574 26.4015 8.85877 26.3478 8.87035 26.3066L9.33293 24.5H9.96924L10.4318 26.3066C10.442 26.3463 10.4535 26.4 10.4666 26.4676C10.481 26.5338 10.4955 26.6059 10.51 26.6838C10.5245 26.7618 10.5375 26.8382 10.5491 26.9132C10.5621 26.9868 10.5715 27.0507 10.5773 27.1051C10.5875 27.0316 10.6012 26.9426 10.6186 26.8382C10.6374 26.7324 10.657 26.6272 10.6772 26.5228C10.6989 26.4184 10.7178 26.3309 10.7337 26.2603L11.1376 24.5H11.8Z"
      fill={styles.highlight}
    />
  </svg>
);
